import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import assignImg from "../../../../shared-library/assets/images/SalesJourney/Home/Assign.svg";
var AssignLeadPopup = function (props) {
    return (React.createElement("div", { className: "assign-lead" },
        React.createElement("img", { src: assignImg }),
        React.createElement("div", { className: "DMSans_16_500 txt_primaryGrey pb-5 pt-3 text-center line-140" },
            "Are You Sure You Want To Assign This Lead",
            React.createElement("br", null),
            " To Yourself."),
        React.createElement("div", { className: "assign-buttons d-flex" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Assign To Me", type: "button", onClick: function () {
                    props.getSelfAssign(props.refreshLeadFunction);
                } }),
            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", onClick: function () { return props.closePopup(false); } }))));
};
export default AssignLeadPopup;
